import React, { useEffect, useState } from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { api } from "@/lib/api";
import { SEO } from "@/lib/seo";
import { Badge } from "@/components/ui/badge";
import { CalendarDays, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const fmt = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

export default function EventsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/events").then(setItems).catch(() => {}); }, []);
  return (
    <main>
      <SEO title="Events" description="Upcoming, ongoing and past CAF events across India." breadcrumbs={[{name: "Home", href:"/"},{name:"Events", href:"/events"}]} jsonLd={items.length ? { "@context":"https://schema.org","@type":"ItemList", itemListElement: items.map((e, i) => ({ "@type":"ListItem", position: i+1, item: { "@type":"Event", name: e.title, startDate: e.start_date, location: { "@type":"Place", name: e.location }, image: e.image } })) } : undefined} />
      <PageHeader eyebrow="Events" title="Where CAF meets citizens — in person, on-ground." lead="Volunteer drives, workshops, medical camps, fellowships and summits." />
      <section className="container-wide py-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {items.map((e) => (
          <article key={e.id} className="rounded-2xl border border-border overflow-hidden bg-background card-lift" data-testid={`event-card-${e.slug}`}>
            <div className="aspect-[16/9] overflow-hidden"><img src={e.image} alt={e.title} loading="lazy" className="h-full w-full object-cover" /></div>
            <div className="p-5">
              <div className="flex items-center gap-2"><Badge className="badge-orange border">{e.category}</Badge><Badge className="badge-green border">{e.status}</Badge></div>
              <h3 className="heading-3 mt-2 text-lg">{e.title}</h3>
              <p className="text-sm text-[hsl(var(--muted-ink))] mt-2 line-clamp-3">{e.summary}</p>
              <div className="mt-3 flex items-center gap-4 text-xs text-[hsl(var(--muted-ink))]">
                <span className="inline-flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" /> {fmt(e.start_date)}</span>
                <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {e.location}</span>
              </div>
              <div className="mt-4"><Link to={e.registration_url || "/volunteer"} className="text-sm font-semibold text-[hsl(var(--orange))] hover:underline">Register / Participate →</Link></div>
            </div>
          </article>
        ))}
      </section>
    </main>
  );
}
